import {useAppSelector} from '@src/Store/hooks';

export const usePasswordValidation = () => {
  const {rules} = useAppSelector(state => state.settings.password);
  return {rules};
};
